import React, { Component } from "react";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import AfshanRug from "./rugTemplates/afshanRug";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import ModernRug from "./rugTemplates/modernRug";
import { Link } from "react-router-dom";

export default class RugsWishListMobileSidebar extends Component {
  render() {
    let wishList = [];
    this.props.wishList.map((rug, i) => {
      let key = rug.type + i;
      switch (rug.type) {
        case "lachak-toranj":
          wishList.push(
            <div className="check" key={key}>
              <LachakToranjRug
                background={rug.background}
                border={rug.border}
                corner={rug.corner}
                toranj={rug.toranj}
                show={true}
              />
            </div>
          );
          break;
        case "kheshti":
          wishList.push(
            <div className="check" key={key}>
              <KheshtiRug
                background={rug.background}
                tile={rug.tile}
                show={true}
              />
            </div>
          );
          break;
        case "modern":
          wishList.push(
            <div className="check" key={key}>
              <ModernRug
                background={rug.background}
                pattern={rug.pattern}
                show={true}
              />
            </div>
          );
          break;
        case "your_picture":
          wishList.push(
            <div className="check" key={key}>
              {/* <span> 23%</span> */}
              <ModernRug
                background={rug.background}
                pattern={rug.pattern}
                show={true}
              />
            </div>
          );
          break;
        default:
          wishList.push(
            <div className="check" key={key}>
              <AfshanRug
                background={rug.background}
                border={rug.border}
                show={true}
              />
            </div>
          );
          break;
      }
      return "";
    });
          if (wishList.length == 0) {
        wishList.push(
            <div className="check">
            </div>
          );
      }
    return (
      <div className="favorites-list-mobile-display">
        {/* <p className="mr-4"> {this.props.texts["wishList"]} </p> */}
        <div className="ul-body relative">
          {wishList}
          <button onClick={this.props.wishListHandler}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#353D57" />
              <path d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z" fill="#353D57" />
            </svg>
            <span>
              {this.props.texts["addToWishList"]}
            </span>
          </button>
          {this.props.wishList.length > 0 && (
          <Link
            to={{
              pathname: "/preview",
              state: { rugs: this.props.wishList },
            }}
          >
            <button className="btn-preview btn-left">
              <span>{this.props.texts["preview"]}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99953 13.78C9.87286 13.78 9.7462 13.7333 9.6462 13.6333L5.29953 9.28668C4.59286 8.58001 4.59286 7.42001 5.29953 6.71335L9.6462 2.36668C9.83953 2.17335 10.1595 2.17335 10.3529 2.36668C10.5462 2.56001 10.5462 2.88001 10.3529 3.07335L6.0062 7.42001C5.6862 7.74001 5.6862 8.26001 6.0062 8.58001L10.3529 12.9267C10.5462 13.12 10.5462 13.44 10.3529 13.6333C10.2529 13.7267 10.1262 13.78 9.99953 13.78Z" fill="white" />
              </svg>
            </button>
          </Link>
        )}
        </div>
      </div>
    );
  }
}
